import Markdown from 'markdown-to-jsx';
import styled, { css } from 'styled-components';
import { P, spacingHelper, Stack, Strong } from '@property.com.au/ui-kit';

const Wrapper = styled(Stack).attrs({ gap: 'extraSmall' })``;

const listStyle = css`
  margin-bottom: ${spacingHelper('twoExtraSmall')};
  margin-left: ${spacingHelper('large')};
`;

const List = styled.ul`
  & > li {
    list-style-type: disc;
    ${listStyle}
  }
`;

const OrderedList = styled.ol`
  & > li {
    list-style-type: decimal;
    ${listStyle}
  }
`;

const components = {
  p: P,
  strong: Strong,
  ul: List,
  ol: OrderedList,
};

const MarkdownRenderer = ({ children }: { children: string }) => {
  return <Markdown options={{ overrides: components, wrapper: Wrapper }}>{children}</Markdown>;
};

export default MarkdownRenderer;
